<h2 mat-dialog-title>Fatture SDI da importare</h2>

<mat-dialog-content>
  <table mat-table [dataSource]="data.items" class="w-100">

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          [checked]="isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          (change)="toggleAllRows()"
        ></mat-checkbox>
      </th>

      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          [checked]="selection.isSelected(row)"
          (click)="$event.stopPropagation()"
          (change)="selection.toggle(row)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="IdentificativoSdI">
      <th mat-header-cell *matHeaderCellDef>Identificativo SDI</th>
      <td mat-cell *matCellDef="let row">{{ row.IdentificativoSdI }}</td>
    </ng-container>

    <ng-container matColumnDef="IdentificativoPubblicoLotto">
      <th mat-header-cell *matHeaderCellDef>Lotto</th>
      <td mat-cell *matCellDef="let row">{{ row.IdentificativoPubblicoLotto }}</td>
    </ng-container>

    <ng-container matColumnDef="Data">
      <th mat-header-cell *matHeaderCellDef>Data</th>
      <td mat-cell *matCellDef="let row">{{ row.Data }}</td>
    </ng-container>

    <ng-container matColumnDef="DataRicezione">
      <th mat-header-cell *matHeaderCellDef>Data ricezione</th>
      <td mat-cell *matCellDef="let row">{{ row.DataRicezione }}</td>
    </ng-container>

    <ng-container matColumnDef="Origine">
      <th mat-header-cell *matHeaderCellDef>Origine</th>
      <td mat-cell *matCellDef="let row">{{ row.Origine }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="selection.toggle(row)"
    ></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="annulla()">Annulla</button>

  <button
    mat-flat-button
    color="primary"
    [disabled]="!selection.selected.length"
    (click)="conferma()"
  >
    Importa selezionate
  </button>
</mat-dialog-actions>
